import { Divider } from 'antd/lib'
import styles from './Attributes.module.less'

export const AttributeHeaderTitle = () => {
    return (
        <Divider orientation="center" className={styles['divider']}>
            Attributes
        </Divider>
    )
}
